const STORAGE_PREFIX = "activity_feed_freshness_v1";
export const NOTIFICATIONS_LOG_STALE_EVENT = "movie-notifications-log-stale";

const getStorage = () => {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch (_error) {
    return null;
  }
};

const getMarkerKey = (feed: string, userId: string, scope = "") =>
  `${STORAGE_PREFIX}:${feed}:${String(userId || "")}:${scope}`;

const readMarker = (key: string) => {
  try {
    const value = Number(getStorage()?.getItem(key));
    return Number.isFinite(value) && value > 0 ? value : 0;
  } catch (_error) {
    return 0;
  }
};

const markStale = (key: string) => {
  try {
    const storage = getStorage();
    if (!storage) return 0;
    // Keep the marker strictly ahead of any validation timestamp produced in
    // the same millisecond as the user action.
    const nextValue = Math.max(Date.now() + 1, readMarker(key) + 1);
    storage.setItem(key, String(nextValue));
    return nextValue;
  } catch (_error) {
    // Freshness markers are an optimization. A storage failure must never
    // turn a successful user action into a failed rating/activity operation.
    return 0;
  }
};

export const markActivityLogStale = (userId: string) =>
  markStale(getMarkerKey("diary", userId));

export const getActivityLogInvalidatedAt = (userId: string) =>
  readMarker(getMarkerKey("diary", userId));

export const markNotificationsLogStale = (userId: string, scope = "owner") => {
  const markedAt = markStale(getMarkerKey("events", userId, scope));
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(NOTIFICATIONS_LOG_STALE_EVENT, {
      detail: { userId: String(userId || ""), scope, markedAt }
    }));
  }
  return markedAt;
};

export const getNotificationsLogInvalidatedAt = (userId: string, scope = "owner") =>
  readMarker(getMarkerKey("events", userId, scope));
